import { ILanguageData } from 'shared/types';

export enum OutputTypeEnum {
  CARD = 'card',
  PHONE = 'phone',
  BANK_ACCOUNT = 'bank_account',
  YURTA_WALLET = 'yurta_wallet',
  UZMOBILE_GSM = 'uzmobile_gsm',
  UZMOBILE_CDMA = 'uzmobile_cdma',
  UCELL = 'ucell',
  PERFECTUM = 'perfectum',
  MOBIUZ = 'mobiuz',
  OQ = 'oq',
  BEELINE = 'beeline',
  OSON_WALLET = 'oson_wallet',
}

export interface IReasonItem {
  id: number;
  title: ILanguageData;
}

interface IWithdrawal_service {
  id: number;
  service: string;
  currency: string;
}

export interface IDowntime {
  id: number;
  reason_id: number;
  is_active: boolean;
  unavailable_until_at: string | null;
}

export interface IFinanceOperatorsItem {
  id: number;
  type: string;
  title: ILanguageData;
  description: ILanguageData;
  is_needed_validation: boolean;
  country_ids: number[];
  city_ids: number[];
  created_at: string;
  limit: string;
  commission_min: number;
  commission_percent: number;
  withdrawal_service: IWithdrawal_service;
  downtime: IDowntime;
  app_type: string;
}

export interface IFinanceOperatorTableData extends Pick<IFinanceOperatorsItem, 'id' | 'type'> {
  country_name: string;
  limit: string;
  type: string;
  service: string;
  app_type: string;
}

export type PartialDowntime = Partial<IDowntime>;
export type PartialFinanceOperatorsItem = Partial<IFinanceOperatorsItem>;
